import { setLoading } from '../actions/page';
import { RECEIVE_LABEL_URL, RECEIVE_PRINTERLESS_URL } from '../actions/returnSubmission';
import { toggleTooltip } from '../actions/tooltip';
import { SUBMIT_CART } from '../constants/endpoints';
import { ActionTypes } from '../constants/enums';
import { store } from '../store';
import { returnFeeService } from '../services';

export const submitCart = async (cart) => {
  try {
    const {
      page: { locale, overrideCode } = {},
      retailerSettings: { name: retailerMoniker } = {},
      landingPage: { landingForm: { email } } = {},
      returnItems: { cartActions = [] },
      tooltip,
      refunds: { selectedType: refund_type },
      resolutions: { resolutionType: resolution_type },
    } = store.getState();
    const isReturnOrExchange =
      cartActions.length > 0 && cartActions?.every((action) => action !== ActionTypes.Claim);
    store.dispatch(setLoading(true));

    if (tooltip.claimPostErrorTooltip) {
      store.dispatch(toggleTooltip('claimPostErrorTooltip'));
    }
    if (tooltip.returnPostErrorTooltip) {
      store.dispatch(toggleTooltip('returnPostErrorTooltip'));
    }

    const response = await fetch(SUBMIT_CART, {
      method: 'POST',
      headers: {
        'X-Retailer-Moniker': retailerMoniker,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        order_number: cart.order_number,
        email,
        locale,
        eligibility_override_code: overrideCode,
        refund_type,
        cart: {
          estimated_refund: returnFeeService.getEstimatedRefund(),
          preferred_resolution_option: resolution_type,
          items: cart.return_items.map((item) => ({
            item_id: `${item.item_id}`,
            quantity: item.return_qty,
            action_type: item.action_type,
            exchange_for: item.exchange_item,
            reason: {
              action_reason_id: item.action_reason_id,
              uploaded_images:
                item.uploadedImages?.length > 0
                  ? item.uploadedImages?.map((e) => ({
                      path: e.path,
                      url: e.path + e.filename,
                      file_name: e.filename,
                    }))
                  : [],
              user_comments: item.user_comment,
            },
          })),
          ...(isReturnOrExchange
            ? {
                return_method: cart.return_method,
                carrier_moniker: cart.return_carrier,
                cns_id: cart.return_to_dc,
                drop_off_location: cart.drop_off_location,
              }
            : {}),
        },
      }),
    });
    const data = await response.json();
    return data;
  } finally {
    store.dispatch(setLoading(false));
  }
};

export const processReturnExchange = (data) => {
  const shipment = data.shipments?.[0];
  const shippingLabel = shipment?.labels?.find((label) => label.label_type === 'label');
  const qrCodeLabel = shipment?.labels?.find((label) => label.label_type === 'qrcode');
  const destination = shipment?.destination_address;

  if (shippingLabel?.url) {
    store.dispatch({
      type: RECEIVE_LABEL_URL,
      data: {
        labelUrl: shippingLabel.url,
      },
    });
  }

  if (qrCodeLabel?.url) {
    store.dispatch({
      type: RECEIVE_PRINTERLESS_URL,
      data: {
        printerlessUrl: qrCodeLabel.url,
      },
    });
  }

  const returnInfo = {
    encrypted_return_id: data.id,
    order_number: data.order_number,
    return_method: shipment?.return_method,
    return_status: data.status,
    return_tracking_url: shipment?.tracking_url,
    tracking_number: shipment?.tracking_number,
    rma_number: data.rma_number,
    return_carrier: shipment?.carrier_moniker,
    carrier_moniker: shipment?.carrier_moniker,
    product_type: data.action_type,
    return_address: {
      to_name: destination?.name,
      to_first_name: destination?.first_name,
      to_last_name: destination?.last_name,
      to_company: destination?.company,
      to_address1: destination?.address1,
      to_address2: destination?.address2,
      to_city: destination?.city,
      to_state: destination?.region_code,
      to_zip5: destination?.postal_code,
      to_country: destination?.country,
      to_country_code: destination?.country_code,
      to_phone: destination?.phone,
      to_email: destination?.email,
    },
    is_label_data_present: !!shippingLabel?.url,
    is_qrcode_present: !!qrCodeLabel?.url,
  };

  return returnInfo;
};
